import React from 'react';

import { Check, X } from 'lucide-react';

const ComparisonTable: React.FC = () => {
  return (
    <div className="overflow-x-auto w-full">
      <table className="min-w-full bg-white rounded-lg shadow-xl border-4 border-gray-300 divide-y divide-gray-300">
        <thead>
          <tr className="bg-blue-100">
            <th className="p-5 text-left font-bold text-gray-800 border-b-4 border-r-2 border-gray-300">
              Características
            </th>
            <th className="p-5 text-center font-bold text-gray-800 border-b-4 border-r-2 border-gray-300">
              Digitalización Básica
            </th>
            <th className="p-5 text-center font-bold text-gray-800 border-b-4 border-r-2 border-gray-300">
              Crecimiento y Posicionamiento Digital
            </th>
            <th className="p-5 text-center font-bold text-gray-800 border-b-4 border-r-2 border-gray-300">
              Automatización y Digitalización Total
            </th>
            <th className="p-5 text-center font-bold text-gray-800 border-b-4 border-gray-300">
              Plan Corporativo de Innovación
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-300">
          <tr className="hover:bg-gray-50 transition-colors">
            <td className="p-5 border-r-2 border-gray-300 font-medium">Página Web</td>
            <td className="p-5 text-center border-r-2 border-gray-300">Básica (4 secciones)</td>
            <td className="p-5 text-center border-r-2 border-gray-300">Avanzada (6 secciones)</td>
            <td className="p-5 text-center border-r-2 border-gray-300">Premium a medida</td>
            <td className="p-5 text-center bg-white">Desarrollo a medida</td>
          </tr>
          <tr className="bg-gray-50 hover:bg-gray-100 transition-colors">
            <td className="p-5 border-r-2 border-gray-300 font-medium">Identidad Visual</td>
            <td className="p-5 text-center border-r-2 border-gray-300">Básica</td>
            <td className="p-5 text-center border-r-2 border-gray-300">
              <Check className="inline h-5 w-5 text-green-500" />
            </td>
            <td className="p-5 text-center border-r-2 border-gray-300">
              <Check className="inline h-5 w-5 text-green-500" />
            </td>
            <td className="p-5 text-center bg-white">
              <Check className="inline h-5 w-5 text-green-500" />
            </td>
          </tr>
          <tr className="hover:bg-gray-50 transition-colors">
            <td className="p-5 border-r-2 border-gray-300 font-medium">SEO</td>
            <td className="p-5 text-center border-r-2 border-gray-300">Inicial</td>
            <td className="p-5 text-center border-r-2 border-gray-300">Avanzado</td>
            <td className="p-5 text-center border-r-2 border-gray-300">Avanzado</td>
            <td className="p-5 text-center bg-white">
              <Check className="inline h-5 w-5 text-green-500" />
            </td>
          </tr>
          <tr className="bg-gray-50 hover:bg-gray-100 transition-colors">
            <td className="p-5 border-r-2 border-gray-300 font-medium">Google My Business</td>
            <td className="p-5 text-center border-r-2 border-gray-300">
              <Check className="inline h-5 w-5 text-green-500" />
            </td>
            <td className="p-5 text-center border-r-2 border-gray-300">Con gestión de reseñas</td>
            <td className="p-5 text-center border-r-2 border-gray-300">
              <Check className="inline h-5 w-5 text-green-500" />
            </td>
            <td className="p-5 text-center bg-white">
              <Check className="inline h-5 w-5 text-green-500" />
            </td>
          </tr>
          <tr className="hover:bg-gray-50 transition-colors">
            <td className="p-5 border-r-2 border-gray-300 font-medium">Integración con WhatsApp</td>
            <td className="p-5 text-center border-r-2 border-gray-300">
              <Check className="inline h-5 w-5 text-green-500" />
            </td>
            <td className="p-5 text-center border-r-2 border-gray-300">
              <Check className="inline h-5 w-5 text-green-500" />
            </td>
            <td className="p-5 text-center border-r-2 border-gray-300">
              <Check className="inline h-5 w-5 text-green-500" />
            </td>
            <td className="p-5 text-center bg-white">
              <Check className="inline h-5 w-5 text-green-500" />
            </td>
          </tr>
          <tr className="bg-gray-50 hover:bg-gray-100 transition-colors">
            <td className="p-5 border-r-2 border-gray-300 font-medium">Tienda Online</td>
            <td className="p-5 text-center border-r-2 border-gray-300">
              <X className="inline h-5 w-5 text-red-500" />
            </td>
            <td className="p-5 text-center border-r-2 border-gray-300">
              Básica (hasta 10 productos)
            </td>
            <td className="p-5 text-center border-r-2 border-gray-300">
              Completa (hasta 30 productos)
            </td>
            <td className="p-5 text-center bg-white">
              <Check className="inline h-5 w-5 text-green-500" />
            </td>
          </tr>
          <tr className="hover:bg-gray-50 transition-colors">
            <td className="p-5 border-r-2 border-gray-300 font-medium">
              Automatización de Redes Sociales
            </td>
            <td className="p-5 text-center border-r-2 border-gray-300">
              <X className="inline h-5 w-5 text-red-500" />
            </td>
            <td className="p-5 text-center border-r-2 border-gray-300">
              <Check className="inline h-5 w-5 text-green-500" />
            </td>
            <td className="p-5 text-center border-r-2 border-gray-300">
              <Check className="inline h-5 w-5 text-green-500" />
            </td>
            <td className="p-5 text-center bg-white">
              <Check className="inline h-5 w-5 text-green-500" />
            </td>
          </tr>
          <tr className="bg-gray-50 hover:bg-gray-100 transition-colors">
            <td className="p-5 border-r-2 border-gray-300 font-medium">Correo Corporativo</td>
            <td className="p-5 text-center border-r-2 border-gray-300">
              <X className="inline h-5 w-5 text-red-500" />
            </td>
            <td className="p-5 text-center border-r-2 border-gray-300">
              <Check className="inline h-5 w-5 text-green-500" />
            </td>
            <td className="p-5 text-center border-r-2 border-gray-300">
              <Check className="inline h-5 w-5 text-green-500" />
            </td>
            <td className="p-5 text-center bg-white">
              <Check className="inline h-5 w-5 text-green-500" />
            </td>
          </tr>
          <tr className="hover:bg-gray-50 transition-colors">
            <td className="p-5 border-r-2 border-gray-300 font-medium">Chatbots de Atención</td>
            <td className="p-5 text-center border-r-2 border-gray-300">
              <X className="inline h-5 w-5 text-red-500" />
            </td>
            <td className="p-5 text-center border-r-2 border-gray-300">
              <X className="inline h-5 w-5 text-red-500" />
            </td>
            <td className="p-5 text-center border-r-2 border-gray-300">
              <Check className="inline h-5 w-5 text-green-500" />
            </td>
            <td className="p-5 text-center bg-white">
              <Check className="inline h-5 w-5 text-green-500" />
            </td>
          </tr>
          <tr className="bg-gray-50 hover:bg-gray-100 transition-colors">
            <td className="p-5 border-r-2 border-gray-300 font-medium">Facturación Electrónica</td>
            <td className="p-5 text-center border-r-2 border-gray-300">
              <X className="inline h-5 w-5 text-red-500" />
            </td>
            <td className="p-5 text-center border-r-2 border-gray-300">
              <X className="inline h-5 w-5 text-red-500" />
            </td>
            <td className="p-5 text-center border-r-2 border-gray-300">
              <Check className="inline h-5 w-5 text-green-500" />
            </td>
            <td className="p-5 text-center bg-white">
              <Check className="inline h-5 w-5 text-green-500" />
            </td>
          </tr>
          <tr className="hover:bg-gray-50 transition-colors">
            <td className="p-5 border-r-2 border-gray-300 font-medium">Publicidad Digital</td>
            <td className="p-5 text-center border-r-2 border-gray-300">
              <X className="inline h-5 w-5 text-red-500" />
            </td>
            <td className="p-5 text-center border-r-2 border-gray-300">
              <X className="inline h-5 w-5 text-red-500" />
            </td>
            <td className="p-5 text-center border-r-2 border-gray-300">
              Inicial (Google/Facebook Ads)
            </td>
            <td className="p-5 text-center bg-white">
              <Check className="inline h-5 w-5 text-green-500" />
            </td>
          </tr>
          <tr className="bg-gray-50 hover:bg-gray-100 transition-colors">
            <td className="p-5 border-r-2 border-gray-300 font-medium">Dashboards y Reportes</td>
            <td className="p-5 text-center border-r-2 border-gray-300">
              <X className="inline h-5 w-5 text-red-500" />
            </td>
            <td className="p-5 text-center border-r-2 border-gray-300">
              <X className="inline h-5 w-5 text-red-500" />
            </td>
            <td className="p-5 text-center border-r-2 border-gray-300">
              <Check className="inline h-5 w-5 text-green-500" />
            </td>
            <td className="p-5 text-center bg-white">
              <Check className="inline h-5 w-5 text-green-500" />
            </td>
          </tr>
          <tr className="hover:bg-gray-50 transition-colors">
            <td className="p-5 border-r-2 border-gray-300 font-medium">
              Automatización de Procesos
            </td>
            <td className="p-5 text-center border-r-2 border-gray-300">
              <X className="inline h-5 w-5 text-red-500" />
            </td>
            <td className="p-5 text-center border-r-2 border-gray-300">
              <X className="inline h-5 w-5 text-red-500" />
            </td>
            <td className="p-5 text-center border-r-2 border-gray-300">
              <Check className="inline h-5 w-5 text-green-500" />
            </td>
            <td className="p-5 text-center bg-white">
              <Check className="inline h-5 w-5 text-green-500" /> (Avanzada)
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default ComparisonTable;
